<div class="announcement-sidebar">
  @if (isOpen) {
    <div class="announcement-sidebar__backdrop" (click)="close()"></div>
  }
  <aside
    class="announcement-sidebar__panel"
    [class.announcement-sidebar__panel--open]="isOpen"
    role="dialog"
    aria-modal="true"
    [attr.aria-hidden]="!isOpen"
    [attr.aria-label]="'ANNOUNCEMENTS.TITLE' | translate"
    >
    <header class="announcement-sidebar__header">
      <h5>{{ 'ANNOUNCEMENTS.TITLE' | translate }}</h5>
      <button
        #closeBtn
        type="button"
        class="btn-close"
        (click)="close()"
        [attr.aria-label]="'ANNOUNCEMENTS.CLOSE' | translate"
      ></button>
    </header>

    <div class="announcement-sidebar__actions">
      <button type="button" class="btn btn-sm v-btn-link" (click)="markAllRead()">
        {{ 'ANNOUNCEMENTS.MARK_ALL_READ' | translate }}
      </button>
    </div>

    @if (!isLoading && announcements.length === 0) {
      <p class="announcement-sidebar__empty">
        {{ 'ANNOUNCEMENTS.EMPTY' | translate }}
      </p>
    }

    <ul class="announcement-sidebar__list">
      @for (announcement of announcements; track announcement) {
        <li>
          <button
            type="button"
            class="announcement-item"
            [class.announcement-item--unread]="!announcement.is_read"
            (click)="onItemClick(announcement)"
            >
            <span class="announcement-item__title">{{ announcement.title }}</span>
            @if (!isExpanded(announcement)) {
              <span class="announcement-item__preview">{{
                previewOf(announcement)
              }}</span>
            }
            @if (isExpanded(announcement)) {
              <div
                class="announcement-item__body"
                [innerHTML]="quillHtml(announcement.body)"
              ></div>
            }
            <span class="announcement-item__date">{{
              announcement.published_at | date: 'mediumDate'
            }}</span>
          </button>
        </li>
      }
    </ul>

    <footer class="announcement-sidebar__footer">
      <a [routerLink]="['/notifications']" (click)="close()">
        {{ 'ANNOUNCEMENTS.VIEW_ALL' | translate }}
      </a>
    </footer>
  </aside>
</div>
